/**
 * .
 * Created by jlado on 8/2/18.
 */
export class MailTemplateTag {

    code: string;
    startTag: string;
    finishTag: string;
    description: string;

    constructor(other ?: MailTemplateTag) {
        if (other) {
            this.code = other.code;
            this.startTag = other.startTag;
            this.finishTag = other.finishTag;
            this.description = other.description;
        }
    }

    toString() {
        return this.description;
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/mailTemplateTag.ts
 **/